import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  greyText: {
    color: theme.palette.grey[700],
  },
  allPlansButton: {
    paddingLeft: 0,
    color: theme.palette.grey[600],
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(3),
  },
  paymentDetailsCard: {
    marginTop: theme.spacing(3),
    boxShadow: 'none !important',
  },
  termsText: {
    marginTop: theme.spacing(3),
    color: theme.palette.grey[700],
    lineHeight: theme.typography.subtitle1.lineHeight,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paymentMethodFormControl: {
    marginBottom: theme.spacing(2),
  },
  paymentOption: {
    '& span': {
      lineHeight: 0,
    },
    '& img': {
      marginRight: theme.spacing(1),
    },
  },
  paymentOptionDisabled: {
    opacity: 0.5,
  },
  checkbox: {
    width: 16,
    height: 16,
    float: 'left',
    marginRight: theme.spacing(1),
  },
}));
